import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	termsWithFreeTrial: {
		id: 'sisu.payment.termsWithFreeTrial',
		defaultMessage:
			'By clicking "Start Your Trial", you agree to be automatically billed for {product} at {price} after your trial ends and every year until cancelled. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for a user subscribing with a free trial',
	},
	termsWithoutFreeTrial: {
		id: 'sisu.payment.termsWithoutFreeTrial',
		defaultMessage:
			'By clicking "Get {product}", you agree to be automatically billed for {product} at {price} {cadence} until cancelled. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for a user subscribing without a free trial',
	},
});
